// GENERATED by scripts/gen-realtime-events.mjs from REALTIME_EVENT_TYPE_BY_KIND in
// server/lib/notify/eventContract.js — do not edit. `node scripts/gen-realtime-events.mjs
// --check` (scripts/check.sh --step wire-types) fails when this is stale.

/** The realtime channel's event name per normalized domain-event kind. */
export const REALTIME_EVENT_TYPE_BY_KIND = Object.freeze({
  reforecast: "forecast.created",
  resolved: "contract.resolved",
});

/** The channel's event names, in kind order. */
export const REALTIME_EVENT_TYPES = Object.freeze(["forecast.created", "contract.resolved"]);
